import { render, staticRenderFns } from "./openImg.vue?vue&type=template&id=182b88b6&scoped=true&"
import script from "./openImg.vue?vue&type=script&lang=js&"
export * from "./openImg.vue?vue&type=script&lang=js&"
import style0 from "./openImg.vue?vue&type=style&index=0&id=182b88b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182b88b6",
  null
  
)

export default component.exports